<template>
  <v-dialog v-model="dialogShow" persistent max-width="540">
    <v-card>
      <v-card-title class="tipsDialog-title">
        温馨提示
        <v-spacer></v-spacer>
        <p @click="hideDialog" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text class="tipsDialog-mainArea">
        <div style="display:flex;align-items:center">
          <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
          <p class="tipsDialog-mainArea-text">离开当前页面会失去未保存内容<br/>确定离开？</p>
        </div>
        <div class="tipsDialog-mainArea-btnLine">
          <v-btn @click="hideDialog" width="100" height="35" color="#F5F5F5">取消</v-btn>
          <v-btn @click="quitPageOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "QuitScenePage",
  props:["dialogShow","dialogText"],
  methods:{
    quitPageOK(){
      this.$emit("quitScenePageOK");
      this.hideDialog();
    },

    //隐藏弹窗
    hideDialog(){
      this.$emit("hideQuitScenePageDialog")
    }
  },
}
</script>

<style scoped>

</style>